export default "__VITE_ASSET__DPuh2l4O__"